import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, InfinityIcon, ShieldCheckIcon, FileTextIcon, ZapIcon, GlobeIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const MOCKUP = 'https://cdn.magicpatterns.com/uploads/xygDwcuxRgZZERWBx9gkvP/mockup_corrige_sin_fondo.png';
const badges = [{
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: FileTextIcon,
  label: 'Pago único'
}, {
  icon: DownloadIcon,
  label: 'Descarga en PDF'
}, {
  icon: InfinityIcon,
  label: 'Acceso de por vida'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía de 7 días'
}];
const stats = [{
  value: '6',
  label: 'Tomos Premium'
}, {
  value: '6',
  label: 'Bonos Exclusivos'
}, {
  value: '30 min',
  label: 'Tiempo de corrección'
}, {
  value: '100%',
  label: 'Digital'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-brand-cream" data-id="element-115">
      {/* soft brand glow, not a filler blob */}
      <div className="pointer-events-none absolute -top-24 left-1/2 h-64 w-[120%] -translate-x-1/2 rounded-full bg-brand-purpleLight/20 blur-3xl" data-id="element-116" />

      <div className="relative mx-auto w-full max-w-3xl px-4 pb-12 pt-8 text-center sm:pt-10" data-id="element-117">
        {/* Brand wordmark */}
        <div className="mb-5 flex items-center justify-center gap-1.5" data-id="element-118">
          <span className="font-display text-xl font-extrabold tracking-tight text-brand-purple" data-id="element-119">
            KARITO
          </span>
          <span className="font-display text-xl font-extrabold tracking-tight text-brand-pink" data-id="element-120">
            EDUCA
          </span>
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="mx-auto mb-4 inline-block rounded-full bg-brand-teal/15 px-4 py-1.5 text-xs font-extrabold uppercase tracking-wide text-brand-teal sm:text-sm" data-id="element-121">
          Sistema Corrige Evaluaciones en 30 minutos™
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-brand-purpleDark sm:text-5xl" data-id="element-122">
          Recupera hasta{' '}
          <span className="text-brand-pink" data-id="element-123">10 horas cada semana</span> y
          corrige tus evaluaciones en solo{' '}
          <span className="text-brand-teal" data-id="element-124">30 minutos</span>.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.12
      }} className="mx-auto mt-4 max-w-xl text-base font-semibold text-brand-purpleDark/80 sm:text-lg" data-id="element-125">
          Un sistema paso a paso con plantillas inteligentes, comentarios listos
          para usar y herramientas que reducen drásticamente el tiempo que
          dedicas a corregir. Vuelve a disfrutar de tus tardes y tus domingos,
          sin llevar trabajo a casa.
        </motion.p>

        {/* Mockup */}
        <motion.img src={MOCKUP} alt="Sistema Corrige Evaluaciones en 30 minutos — 6 tomos premium y 6 bonos exclusivos de Karito Educa" initial={{
        opacity: 0,
        scale: 0.92
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="animate-floaty mx-auto mt-6 w-full max-w-2xl drop-shadow-2xl" data-id="element-126" />

        {/* Primary CTA */}
        <div id="hero-cta" className="mx-auto mt-4 max-w-md" data-id="element-127">
          <CtaButton sublabel="Acceso inmediato · Pago único · Descarga en PDF · Acceso de por vida" data-id="element-128">
            Quiero corregir evaluaciones en 30 min™
          </CtaButton>
        </div>

        {/* Trust badges */}
        <ul className="mx-auto mt-6 flex max-w-xl flex-wrap items-center justify-center gap-2" data-id="element-129">
          {badges.map(b => <li key={b.label} className="flex items-center gap-1.5 rounded-full bg-white px-3 py-1.5 text-xs font-bold text-brand-purpleDark shadow-sm ring-1 ring-brand-purple/10" data-id="element-130">
              <b.icon className="h-3.5 w-3.5 text-brand-teal" data-id="element-131" />
              {b.label}
            </li>)}
        </ul>

        {/* Stats */}
        <div className="mx-auto mt-8 grid max-w-xl grid-cols-2 gap-3 sm:grid-cols-4" data-id="element-132">
          {stats.map(s => <div key={s.label} className="rounded-2xl bg-white p-4 shadow-sm ring-1 ring-brand-purple/10" data-id="element-133">
              <p className="font-display text-2xl font-extrabold text-brand-purple sm:text-3xl" data-id="element-134">
                {s.value}
              </p>
              <p className="mt-0.5 text-xs font-semibold text-brand-purpleDark/70" data-id="element-135">
                {s.label}
              </p>
            </div>)}
        </div>
      </div>
    </header>;
}